import { CSSProperties } from "react";
import dayjs from 'dayjs';
import { Col, Form, FormInstance, Input, Select, Space } from "antd";
import React from "react";
import { Rule } from "antd/lib/form";

const { Option } = Select;

interface IJalaliDatePickerProps {
    name: string;
    label: string;
    style?: CSSProperties;
    defaultValue?: any;
    onChange?: (value: any) => void;
    placeholder?: string;
    disabled?: boolean;
    value?: any;
    form?: FormInstance;
    rules?: Rule[];
}

interface IJalaliDatePickerStates {
    isLeapYear: boolean;
    currentMonthDays: number;
    year?: number;
    month?: number;
    day?: number;
    value?: any;
}

const monthList: { month: number; title: string; days: number; }[] = [
    { month: 1, title: 'فروردین', days: 31 },
    { month: 2, title: 'اردیبهشت', days: 31 },
    { month: 3, title: 'خرداد', days: 31 },
    { month: 4, title: 'تیر', days: 31 },
    { month: 5, title: 'مرداد', days: 31 },
    { month: 6, title: 'شهریور', days: 31 },
    { month: 7, title: 'مهر', days: 30 },
    { month: 8, title: 'آبان', days: 30 },
    { month: 9, title: 'آذر', days: 30 },
    { month: 10, title: 'دی', days: 30 },
    { month: 11, title: 'بهمن', days: 30 },
    { month: 12, title: 'اسفند', days: 29 },
];

export const CustomJalaliDatePicker = (props: IJalaliDatePickerProps) => {
    const [state, setState] = React.useState<IJalaliDatePickerStates>({ currentMonthDays: 0, isLeapYear: false, value: props.defaultValue });

    const today = dayjs(new Date(), { jalali: true } as any).calendar('jalali').locale('fa');
    const thisYear = today.year();
    let years = [<Option key={null} value={null}>...</Option>];
    for (let i = thisYear; i > thisYear - 100; i--)
        years.push(<Option key={i} value={i}>{i}</Option>);

    let days = [<Option key={null} value={null}>...</Option>];
    for (let i = 1; i <= state.currentMonthDays; i++)
        days.push(<Option key={i} value={i}>{i}</Option>);

    let mounths = monthList.map(m => <Option key={m.month} value={m.month}>{m.title}</Option>);
    const isLeapYearJalali = (year: number) => {
        const matches = [1, 5, 9, 13, 17, 22, 26, 30];
        const modulus = year - (Math.floor(year / 33) * 33);

        for (let i = 0; i !== 8; i++)
            if (matches[i] === modulus)
                return true;
        return false;
    };

    const onYearSelect = (value: any) => {
        if (isLeapYearJalali(value)) {
            setState({ ...state, isLeapYear: true, year: value, month: undefined, day: undefined });
        }
        else {
            setState({ ...state, isLeapYear: false, year: value, month: undefined, day: undefined });
        }
    };

    const onMonthSelect = (value: any) => {
        if (state.isLeapYear && value === 12)
            setState({ ...state, currentMonthDays: 30, month: value, day: undefined });
        else {
            const currentDays = monthList.find(m => m.month === value)?.days;
            setState({ ...state, currentMonthDays: currentDays ?? 0, month: value, day: undefined });
        }
    };

    const onDaySelect = (value: any) => {
        setState({ ...state, day: value });
    };

    React.useEffect(() => {
        if (!state.year || !state.month || !state.day) {
            props.form?.setFields([{ name: props.name, value: undefined }]);
            setState({ ...state, value: undefined });
        }
        else {
            let parsedDate = new Date(dayjs(state.year + '-' + state.month + '-' + state.day, { jalali: true } as any).locale('en').format());
            parsedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            const newValue = parsedDate.toDateString();
            props.form?.setFields([{ name: props.name, value: newValue }]);
            setState({ ...state, value: newValue });
        }
        props.form?.validateFields([props.name]);
    }, [state.year, state.month, state.day]);

    React.useEffect(() => {
        props.onChange && props.onChange(state.value);
    }, [state.value]);

    return (
        <>
            <Form.Item
                name={props.name}
                label={props.label}
                rules={props.rules}
                onReset={() => setState({ currentMonthDays: 0, isLeapYear: false, value: props.defaultValue })}
                extra={
                    <Space style={{ display: 'flex', position: "absolute", top: 0, right: 0 }}>
                        <Col key="year" style={{ display: 'flex', alignItems: 'center', width: 'min-content' }}>
                            <Select style={{ width: 80 }} placeholder="سال" disabled={props.disabled} key="year" onSelect={onYearSelect} value={state.year}>
                                {years}
                            </Select>
                        </Col>
                        <Col key="month" style={{ display: 'flex', alignItems: 'center', width: 'min-content' }}>
                            <Select style={{ width: 100 }} placeholder="ماه" disabled={props.disabled || !state.year} key="month" onSelect={onMonthSelect} value={state.month}>
                                {[<Option key={null} value={null}>...</Option>, ...mounths]}
                            </Select>
                        </Col>
                        <Col key="day" style={{ display: 'flex', alignItems: 'center', width: 'min-content' }}>
                            <Select style={{ width: 80 }} placeholder="روز" disabled={props.disabled || (!state.year && !state.month)} key="day" onSelect={onDaySelect} value={state.day}>
                                {days}
                            </Select>
                        </Col>
                    </Space>
                }
            >
                <Input hidden />
            </Form.Item>
        </>
    );
}